The date & time the candidate profile was purchased. This corresponds to the `Event.createDateTime` field in the GraphQL schema.
